import {
  reactQueryGet,
  reactQueryPut,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

export interface UpdateMobileAppSettingsPayload {
  community_setting: {
    ios_app_enabled?: boolean;
    show_ios_app_banner?: boolean;
    mobile_home_segments_order: string[];
  };
}
const show = () => reactQueryGet(internalApi.settings.mobileApp.show());
const update = (payload: UpdateMobileAppSettingsPayload) =>
  reactQueryPut(internalApi.settings.mobileApp.update(), payload);

export const mobileAppSettingsApi = {
  show,
  update,
};
